import { render, staticRenderFns } from "./authorCreate.vue?vue&type=template&id=76e35b34&"
import script from "./authorCreate.vue?vue&type=script&lang=js&"
export * from "./authorCreate.vue?vue&type=script&lang=js&"
import style0 from "./authorCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports